/* eslint-disable @typescript-eslint/no-unused-vars */
import { z } from 'zod'

import type { Equal, ExpectTrue } from '../types/validation'

import { type Image, ImageSchema } from './image'

/* TypeScript */
export type DiscountBannerApiProps = {
  technicalName?: string
  discountType: 'military' | 'student'
  title: string
  description?: string
  ctaLabel: string
  secondaryCtaLabel?: string
  image: Image
}

/* Schemas */
export const DiscountBannerApiPropsSchema = z.object({
  technicalName: z.string().optional(),
  discountType: z.enum(['military', 'student']),
  title: z.string(),
  description: z.string().optional(),
  ctaLabel: z.string(),
  secondaryCtaLabel: z.string().optional(),
  image: ImageSchema,
})

/* Schemas validation */
type TestDiscountBannerProps = ExpectTrue<
  Equal<DiscountBannerApiProps, z.infer<typeof DiscountBannerApiPropsSchema>>
>
